// 主题服务，用于动态切换主题

const DEFAULT_THEME = 'minimalist';

const themes = {
  minimalist: {
    name: '简约黑白',
    colors: {
      '--el-color-primary': '#1A1A1A',
      '--el-color-primary-light-3': '#333333',
      '--el-color-primary-light-5': '#4D4D4D',
      '--el-color-primary-light-7': '#808080',
      '--el-color-primary-light-8': '#A6A6A6',
      '--el-color-primary-light-9': '#D9D9D9',
      '--el-color-primary-dark-2': '#000000',
      '--bg-color': '#FFFFFF',
      '--card-header-bg': '#F5F5F5',
      '--border-color': '#E5E5E5',
      '--text-color': '#1A1A1A',
      '--text-light': '#666666',
      '--hover-bg': '#F0F0F0'
    }
  },
  classic: {
    name: '经典奢华',
    colors: {
      '--el-color-primary': '#5A4B3F',
      '--el-color-primary-light-3': '#6B5B4F',
      '--el-color-primary-light-5': '#8B7B6F',
      '--el-color-primary-light-7': '#A69B8B',
      '--el-color-primary-light-8': '#C4B7A7',
      '--el-color-primary-light-9': '#E0D4C4',
      '--el-color-primary-dark-2': '#4A3B2F',
      '--bg-color': '#F5F0E6',
      '--card-header-bg': '#F5F0E6',
      '--border-color': '#C4B7A7',
      '--text-color': '#5A4B3F',
      '--text-light': '#8B7B6F',
      '--hover-bg': '#E0D4C4'
    }
  },
  modern: {
    name: '现代简约',
    colors: {
      '--el-color-primary': '#1B4D3E',
      '--el-color-primary-light-3': '#2C5E4F',
      '--el-color-primary-light-5': '#3D7A66',
      '--el-color-primary-light-7': '#6BA896',
      '--el-color-primary-light-8': '#A8D4C6',
      '--el-color-primary-light-9': '#C4E8DA',
      '--el-color-primary-dark-2': '#0F3A2D',
      '--bg-color': '#F0F4F3',
      '--card-header-bg': '#F0F4F3',
      '--border-color': '#D0D8D5',
      '--text-color': '#1B4D3E',
      '--text-light': '#3D7A66',
      '--hover-bg': '#C4E8DA'
    }
  },
  auroraGreen: {
    name: '极光绿',
    colors: {
      '--el-color-primary': '#2E7D32',
      '--el-color-primary-light-3': '#388E3C',
      '--el-color-primary-light-5': '#4CAF50',
      '--el-color-primary-light-7': '#81C784',
      '--el-color-primary-light-8': '#A5D6A7',
      '--el-color-primary-light-9': '#C8E6C9',
      '--el-color-primary-dark-2': '#1B5E20',
      '--bg-color': '#FAFAFA',
      '--card-header-bg': '#E8F5E9',
      '--border-color': '#C8E6C9',
      '--text-color': '#2E7D32',
      '--text-light': '#4CAF50',
      '--hover-bg': '#C8E6C9'
    }
  },
  sunsetOrange: {
    name: '落日橙',
    colors: {
      '--el-color-primary': '#E65100',
      '--el-color-primary-light-3': '#EF6C00',
      '--el-color-primary-light-5': '#FF9800',
      '--el-color-primary-light-7': '#FFB74D',
      '--el-color-primary-light-8': '#FFCC80',
      '--el-color-primary-light-9': '#FFE0B2',
      '--el-color-primary-dark-2': '#BF360C',
      '--bg-color': '#FFF8E1',
      '--card-header-bg': '#FFF8E1',
      '--border-color': '#FFE0B2',
      '--text-color': '#E65100',
      '--text-light': '#FF9800',
      '--hover-bg': '#FFE0B2'
    }
  },
  skyBlue: {
    name: '天空蓝',
    colors: {
      '--el-color-primary': '#0288D1',
      '--el-color-primary-light-3': '#039BE5',
      '--el-color-primary-light-5': '#03A9F4',
      '--el-color-primary-light-7': '#4FC3F7',
      '--el-color-primary-light-8': '#81D4FA',
      '--el-color-primary-light-9': '#B3E5FC',
      '--el-color-primary-dark-2': '#01579B',
      '--bg-color': '#FFFFFF',
      '--card-header-bg': '#E1F5FE',
      '--border-color': '#B3E5FC',
      '--text-color': '#0288D1',
      '--text-light': '#03A9F4',
      '--hover-bg': '#B3E5FC'
    }
  },
  mintCandy: {
    name: '薄荷糖',
    colors: {
      '--el-color-primary': '#26A69A',
      '--el-color-primary-light-3': '#00897B',
      '--el-color-primary-light-5': '#4DB6AC',
      '--el-color-primary-light-7': '#80CBC4',
      '--el-color-primary-light-8': '#A5D6A7',
      '--el-color-primary-light-9': '#C8E6C9',
      '--el-color-primary-dark-2': '#00796B',
      '--bg-color': '#FAFAFA',
      '--card-header-bg': '#E0F2F1',
      '--border-color': '#B2DFDB',
      '--text-color': '#26A69A',
      '--text-light': '#4DB6AC',
      '--hover-bg': '#C8E6C9'
    }
  },
  creamYellow: {
    name: '奶油黄',
    colors: {
      '--el-color-primary': '#F9A825',
      '--el-color-primary-light-3': '#FBC02D',
      '--el-color-primary-light-5': '#FFEB3B',
      '--el-color-primary-light-7': '#FFEE58',
      '--el-color-primary-light-8': '#FFF176',
      '--el-color-primary-light-9': '#FFF9C4',
      '--el-color-primary-dark-2': '#F57F17',
      '--bg-color': '#FFFDE7',
      '--card-header-bg': '#FFFDE7',
      '--border-color': '#FFF59D',
      '--text-color': '#F9A825',
      '--text-light': '#FFCA28',
      '--hover-bg': '#FFF9C4'
    }
  },
  matchaGreen: {
    name: '抹茶绿',
    colors: {
      '--el-color-primary': '#689F38',
      '--el-color-primary-light-3': '#7CB342',
      '--el-color-primary-light-5': '#8BC34A',
      '--el-color-primary-light-7': '#AED581',
      '--el-color-primary-light-8': '#C5E1A5',
      '--el-color-primary-light-9': '#DCEDC8',
      '--el-color-primary-dark-2': '#33691E',
      '--bg-color': '#F1F8E9',
      '--card-header-bg': '#F1F8E9',
      '--border-color': '#C5E1A5',
      '--text-color': '#689F38',
      '--text-light': '#8BC34A',
      '--hover-bg': '#DCEDC8'
    }
  },
  roseGold: {
    name: '珍珠玫瑰金',
    colors: {
      '--el-color-primary': '#B76E79',
      '--el-color-primary-light-3': '#C4858C',
      '--el-color-primary-light-5': '#D4A5AD',
      '--el-color-primary-light-7': '#E8C5C9',
      '--el-color-primary-light-8': '#F0E6E6',
      '--el-color-primary-light-9': '#FFF0F5',
      '--el-color-primary-dark-2': '#8B4B53',
      '--bg-color': '#FDFCF0',
      '--card-header-bg': '#FFF0F5',
      '--border-color': '#F0E6E6',
      '--text-color': '#B76E79',
      '--text-light': '#C4858C',
      '--hover-bg': '#FFF0F5'
    }
  },

  tuscanyGold: {
    name: '托斯卡纳金',
    colors: {
      '--el-color-primary': '#8B4513',
      '--el-color-primary-light-3': '#A0522D',
      '--el-color-primary-light-5': '#CD853F',
      '--el-color-primary-light-7': '#DEB887',
      '--el-color-primary-light-8': '#F4D03F',
      '--el-color-primary-light-9': '#FDF5E6',
      '--el-color-primary-dark-2': '#6B3510',
      '--bg-color': '#FDF5E6',
      '--card-header-bg': '#FFF8DC',
      '--border-color': '#DEB887',
      '--text-color': '#8B4513',
      '--text-light': '#A0522D',
      '--hover-bg': '#FDF5E6'
    }
  }
};

const loadTheme = (themeName) => {
  const theme = themes[themeName];
  if (!theme) {
    console.error('Theme not found:', themeName);
    return;
  }

  const root = document.documentElement;
  
  Object.keys(theme.colors).forEach(key => {
    root.style.setProperty(key, theme.colors[key], 'important');
  });

  localStorage.setItem('theme', themeName);
};

const getCurrentTheme = () => {
  return localStorage.getItem('theme') || DEFAULT_THEME;
};

const initTheme = () => {
  const saved = localStorage.getItem('theme');
  loadTheme(saved || 'minimalist');
};

export {
  themes,
  loadTheme,
  getCurrentTheme,
  initTheme
};
